import { Component, inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  standalone: false,
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrl: './authentication.component.scss'
})
export class AuthenticationComponent {
  private oAuthService: OAuthService = inject(OAuthService);

  constructor() {
    setTimeout(() => {
      this.login();
    }, 2000);
  }

  public login(): void {
    this.oAuthService.initCodeFlow();
  }
}
